






















import { Component, Vue, Emit } from 'vue-property-decorator';

@Component({
  components: {

  }
})
export default class LoginComponent extends Vue {
  public username: string;
  public password: string;

  constructor() {
      super();
      this.username = '';
      this.password = '';
  }

  public async login($event: any): Promise<void> {
      $event.preventDefault();
      const loginOk = await Vue.$svc.login(this.username, this.password);
      if (loginOk) this.onLoggedIn();
  }

  @Emit('onLoggedIn')
  public onLoggedIn() {
    // logged in.
  } 
}
